<template>
  <a-empty v-if="isExist"
      image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
      :image-style="{
      height: '60px',
    }"
  >
    <span slot="description"><a @click="toEdit('/expertInfo/expertLoginEdit')">您已经完成专家信息入库</a> </span>
    <a-button @click="toEdit('/expertInfo/expertLoginEdit')" type="primary">
      去更改信息
    </a-button>
  </a-empty>


  <expert-form v-else ref="eForm" @afterSaveToUrl="onViewUrl"/>
</template>

<script>

import expertForm from '@/epp/expertmain/expertInfo/common/ExpertForm.vue'
import { GetExpertByUserId } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'

export default {
  name: 'ExpertLoginAdd',
  components: {
    expertForm
  },
  data () {
    return {
      isExist: false
    }
  },
  computed: {},
  created () {
    this.getExpert()
  },
  methods: {
    async getExpert () {
      try {
        let res = await GetExpertByUserId()
          this.isExist = !!res.result
      } catch (e) {
        console.log(e.message)
      } finally {
      }
    },
    toEdit(target){
      this.$router.push({ path: target })
    },
    onViewUrl(id){
      this.$router.push({
        path: '/expertInfo/expertLoginView'
      })
    }
  }
}
</script>

<style scoped>

.ant-empty {
  margin: 70px 8px;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}


</style>
